import React from 'react';
import style from './style.scss';

export default () => (
  <div className="footerBar">
    <p className="copyright" >&copy; Kratos {new Date().getFullYear()}</p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/footer/index.js